@if (!vehicle) {
  <lin-spinner></lin-spinner>
}

@if (vehicle) {
  <form lin-layout-form [formGroup]="vehicleForm" (ngSubmit)="saveData()">
    <lin-layout-form-sections-wrapper>
      <lin-layout-form-section layout="triple">
        <label>{{ 'CLIENT.VEHICLES.VEHICLE_ID' | translate }}:</label>
        <mat-form-field>
          <input matInput formControlName="vehicleId" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('vehicleId')" controlName="vehicleId"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <label>{{ 'CLIENT.VEHICLES.TYPE' | translate }}:</label>
        <lin-improved-select
          optionValueKey="id"
          [disabled]='vehicleForm?.get("type")?.disabled'
          [hasSearch]="true"
          [staticSearch]="true"
          [staticList]="true"
          [selectedOption]="vehicle?.typeId || ''"
          [preloadedOptions]="vehicleTypesList"
          [displayOptionLabel]="displayVehicleType"
          (selectOption)="handleVehicleTypeSelect($event.value)"
        ></lin-improved-select>

        <label>{{ 'CLIENT.VEHICLES.MAKE' | translate }}:</label>
        <mat-form-field>
          <input matInput formControlName="make" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('make')" controlName="make"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <label>{{ 'CLIENT.VEHICLES.MODEL' | translate }}:</label>
        <mat-form-field>
          <input matInput formControlName="makeModel" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('makeModel')" controlName="makeModel"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-form-label required>{{ 'CLIENT.VEHICLES.REG_NO' | translate }}:</lin-form-label>
        <mat-form-field>
          <input matInput formControlName="regNo" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('regNo')" controlName="regNo"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <label>{{ 'CLIENT.VEHICLES.PRODUCTION_YEAR' | translate }}:</label>
        <mat-form-field>
          <input matInput formControlName="regDate" autocomplete="off" type="number" min="1900" [max]="currentYear" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('regDate')" controlName="regDate"></lin-form-field-error>
          </mat-error>
        </mat-form-field>
      </lin-layout-form-section>

      <lin-layout-form-section layout="triple">
        <lin-form-label required>{{ 'CLIENT.VEHICLES.VEHICLE_TITLE' | translate }}:</lin-form-label>
        <mat-form-field>
          <input matInput formControlName="defaultLabel" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('defaultLabel')" controlName="defaultLabel"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <ng-container>
          <label>{{ 'CLIENT.VEHICLES.DEPOT' | translate }}:</label>
          <mat-form-field>
            <mat-select formControlName="depot">
              <mat-option [value]="null"></mat-option>
              @for (depot of depotList; track depot.id) {
                <mat-option [value]="depot.id">{{ depot.name }}</mat-option>
              }
            </mat-select>
            <mat-error>
              <lin-form-field-error [control]="vehicleForm.get('depot')" controlName="depot"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        </ng-container>

        <ng-container>
          <label>{{ 'CLIENT.VEHICLES.GROUPS' | translate }}:</label>
          <mat-form-field>
            <mat-select formControlName="groups" multiple>
              @for (group of vehicleGroupList; track group.id) {
                <mat-option [value]="group.id">{{ group.name }}</mat-option>
              }
            </mat-select>
            <mat-error>
              <lin-form-field-error [control]="vehicleForm.get('groups')" controlName="groups"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        </ng-container>

        <label>{{ 'CLIENT.VEHICLES.AVAILABLE_STATUS' | translate }}:</label>
        <mat-checkbox class="unavailable-status" formControlName="isUnavailable"
          >{{ 'CLIENT.VEHICLES.UNAVAILABLE' | translate }}</mat-checkbox
        >

        @if (vehicleForm.controls.isUnavailable.value) {
          <label>{{ 'CLIENT.VEHICLES.UNAVAILABLE_MESSAGE' | translate }}:</label>
          <mat-form-field>
            <input matInput formControlName="unavailableMessage" autocomplete="off" />
            <mat-error>
              <lin-form-field-error [control]="vehicleForm.get('unavailableMessage')" controlName="unavailableMessage"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }
        <lin-form-label>{{ 'CLIENT.VEHICLES.DRIVER' | translate }}:</lin-form-label>
        <mat-form-field>
          <input matInput formControlName="driver" [matAutocomplete]="auto" />
        </mat-form-field>

        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayDriverName">
          @if (isAutocompleteListLoading) {
            <mat-option>
              <mat-spinner strokeWidth="2" diameter="20" color="accent"></mat-spinner>
            </mat-option>
          } @else {
            @for (driver of drivers; track driver.id) {
              <mat-option [value]="driver">
                <span>{{ driver.fullName }}</span>
              </mat-option>
            }
          }
        </mat-autocomplete>

        <label>{{ 'CLIENT.VEHICLES.DRIVING_SINCE' | translate }}:</label>

        <lin-datepicker-field
          formControlName="driverStartDate"
          [placeholder]="'MAIN.CHOOSE_DATE_TIME' | translate"
          [isWithTimePicker]="true"
          [isRange]="false"
        ></lin-datepicker-field>
        @if (driverStartDateError) {
          <mat-error class="error-driver-start">
            <span>{{ driverStartDateError }}</span>
          </mat-error>
        }
      </lin-layout-form-section>

      <lin-layout-form-section layout="triple">
        @if (vehicle) {
          <lin-note-list
            [isClient]="!!vehicle"
            [notesHistory]="clientNotesHistory"
            (addNewNote)="addNote('client', $event)"
            (deleteNote)="deleteNote($event)"
          >
          </lin-note-list>
          @if (user.isAdmin()) {
            <lin-note-list
              [isClient]="!!vehicle"
              [noteText]="'FIELDS.ADMIN_NOTE_TEXT' | translate"
              [notesHistory]="adminNotesHistory"
              (addNewNote)="addNote('admin', $event)"
              (deleteNote)="deleteNote($event)"
              [style.margin-top.px]="'15'"
            >
            </lin-note-list>
          }
        } @else {
          <lin-form-label>
            <span>{{ 'FIELDS.ADD_NEW_NOTE' | translate }}:</span>
            @if (hasPermission(PermissionsSource['FLEET.VEHICLE_LIST.NOTE_HISTORY']) && isEditMode) {
              <a (click)="getNotes()">{{ 'FIELDS.NOTES_HISTORY' | translate }}</a>
            }
          </lin-form-label>
          <mat-form-field>
            <textarea matInput matTextareaAutosize matAutosizeMinRows="7" matAutosizeMaxRows="7" formControlName="clientNote"></textarea>
            <mat-error>
              <lin-form-field-error [control]="vehicleForm.get('clientNote')" controlName="clientNote"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }
      </lin-layout-form-section>
    </lin-layout-form-sections-wrapper>

    <lin-layout-form-toolbar>
      <div fxLayout="column">
        <div fxLayout="row">
          <lin-form-submit-button [isLoading]="isSubmitting" [isDisabled]="!isEditMode">
            {{ 'BUTTONS.SAVE' | translate }}
          </lin-form-submit-button>

          @if (canCorrectInstallationDate) {
            <button
              class="correction-button"
              mat-raised-button=""
              type="button"
              color="accent"
              fxLayoutAlign="center center"
              (click)="openInstallationTimeCorrectionDialog()"
            >
              {{ 'BUTTONS.CORRECT_INSTALLATION_TIME' | translate }}
            </button>
          }
        </div>
      </div>

      <lin-layout-form-toolbar-info>
        <lin-layout-form-toolbar-info-row>
          <lin-layout-form-toolbar-info-label>{{ 'CLIENT.VEHICLES.CREATED' | translate }}:</lin-layout-form-toolbar-info-label>
          <lin-layout-form-toolbar-info-value>
            {{ (vehicle.createdAt | dayjsDateTime) || '-' }} {{ vehicle.createdBy ? ('USER.BY' | translate) + ' ' + vehicle.createdBy.fullName
            : '' }}
          </lin-layout-form-toolbar-info-value>
        </lin-layout-form-toolbar-info-row>

        <lin-layout-form-toolbar-info-row>
          <lin-layout-form-toolbar-info-label>{{ 'CLIENT.VEHICLES.LAST_UPDATED' | translate }}:</lin-layout-form-toolbar-info-label>
          <lin-layout-form-toolbar-info-value>
            {{ (vehicle.updatedAt | dayjsDateTime) || '-' }} {{ vehicle.updatedBy ? ('USER.BY' | translate) + ' ' + vehicle.updatedBy.fullName
            : '' }}
          </lin-layout-form-toolbar-info-value>
        </lin-layout-form-toolbar-info-row>
      </lin-layout-form-toolbar-info>
    </lin-layout-form-toolbar>
  </form>
}
